<div class="hint-overlay" *ngIf="show" (click)="dismiss()"></div>